require('./edit');
require('./new');

import { createAppWrap } from '../../create_app_wrap';
import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import modalYahooAuth from '../../components/_modal_yahoo_auth';
import templateConfigEditor from '../../components/_template_config_editor';
import pageList from './_page_list_component';

const view = '[data-view="custom_page-index"]';
const init = () => {
    createAppWrap({
        el: view,
        data () {
            return {
                // 初回案内画面フラグ
                first_create: false,
                // 公開ページ一覧
                released_pages: [],
                // 下書きページ一覧
                draft_pages: [],
            };
        },
        mixins: [
            commonMixin,
            flashMessageMixin,
        ],
        components: {
            // ヤフーAPIトークン認証チェックコンポーネント
            'modal-yahoo-auth': modalYahooAuth,
            // テンプレート設定コンポーネント
            'template-config-editor': templateConfigEditor,
            // ページリストコンポーネント
            'page-list': pageList,
        },
        computed: {
            // ページ一覧が一つでもあるか
            hasPages: function () {
                if (this.released_pages.length) {
                    return true;
                }
                if (this.draft_pages.length) {
                    return true;
                }
                return false;
            },
        },
        methods: {
            // 一覧取得
            setPages: async function () {
                let message = this.exception_error_message;
                try {
                    this.$_loading();
                    const response = await axios.get('/custom_page/get_pages');
                    if (response.data.status === 'OK') {
                        // 各リストへ
                        const pages = response.data.data;
                        this.released_pages = pages.released;
                        this.draft_pages = pages.draft;
                        // エラーメッセージを空にする
                        message = '';
                    } else {
                        message = response.data.message;
                    }
                } catch (e) {
                    message = this.getCatchMessage(e);
                }
                if (message) console.error(message);
                this.$_unloading();
            },
            // ヤフーTOKEN認証チェック後に検索実行
            isValidToken: async function (boolean) {
                if (boolean) {
                    await this.setPages();
                    // DBにページデータなし → 初回案内画面
                    if (!this.hasPages) {
                        this.first_create = true;
                    }
                }
            },
            // 新規作成ページへ
            gotoNew: function () {
                window.location.href = '/custom_page/new';
            },
        }
    });
};

if (document.querySelector(view)) {
    init();
}
